export enum ApprovalSource {
    pendingArea = 1,
}